import * as React from "react";

// 订单列表中的 数/成/儿/婴 列

export default {
  render: (text, record) => {
    return (
      <React.Fragment>
        <span>{record.saleNum || 0}</span>/<span>{record.adultNum || 0}</span>/
        <span>{record.childrenNum || 0}</span>/
        <span>{record.babyNum || 0}</span>
      </React.Fragment>
    );
  }
};
